// 获取常量的服务
import Http from '@/libs/http';

export default {

  // 缓存对象
  _cache: {},
  _promiseCache: {},

  // 创建一个缓存请求方法
  createCachedRequest(key, promiseFn) {
    // 如果已有缓存数据,直接返回
    if (this._cache[key]) {
      return Promise.resolve(this._cache[key]);
    }

    // 如果已经在请求中,返回请求promise
    if (this._promiseCache[key]) {
      return this._promiseCache[key];
    }

    // 发起新请求并缓存promise
    const promise = promiseFn().then((data) => {
      this._cache[key] = data;
      delete this._promiseCache[key];
      return data;
    }).catch((err) => {
      delete this._promiseCache[key];
      return Promise.reject(err);
    });

    this._promiseCache[key] = promise;
    return promise;
  },
  // 获取国籍列表
  getNationalityList() {
    return this.createCachedRequest('nationalityList', () => Http.post('/sys/country_get', {}).then(res => res.country_set));
  },
};



// WEBPACK FOOTER //
// ./src/services/consts-service.js